export default __webpack_public_path__ + "206ea6018d89e641c0c08a336dae7842.png";